<app-page-content>
<app-doenkids-menu-bar menuBar [showBackButton]="true" [loading]="loading$ | async">
</app-doenkids-menu-bar>
<div content class="program-template-reorder">
  @if (programCategoryDetails) {
    <h2>{{ programCategoryDetails.name }}</h2>
  }

  @if (programCategoryTemplates.length > 0 && programCategoryTemplateBundles.length > 0) {
    <mat-tab-group [(selectedIndex)]="selectedTab" mat-stretch-tabs="false" mat-align-tabs="start">
      <mat-tab [label]="'program_template_reorder.tab.templates' | translate">
        <ng-container *ngTemplateOutlet="programCategoryTemplateList"></ng-container>
      </mat-tab>
      <mat-tab [label]="'program_template_reorder.tab.template_bundles' | translate">
        <ng-container *ngTemplateOutlet="programCategoryTemplateBundleList"></ng-container>
      </mat-tab>
    </mat-tab-group>
  }

  @if (programCategoryTemplates.length > 0 && programCategoryTemplateBundles.length === 0) {
    <div>
      <ng-container *ngTemplateOutlet="programCategoryTemplateList"></ng-container>
    </div>
  }

  @if (programCategoryTemplates.length === 0 && programCategoryTemplateBundles.length > 0) {
    <div>
      <ng-container *ngTemplateOutlet="programCategoryTemplateBundleList"></ng-container>
    </div>
  }
</div>

<ng-template #programCategoryTemplateList>
  <div cdkDropList class="program-category-template-list" (cdkDropListDropped)="droppedTemplate($event)">
    @for (template of programCategoryTemplates; track template) {
      <div class="category-box" [class.draggable]="(isAdmin$ | async) || (hasWritePermissionOnAtLeastOneCustomerOUInCurrentNodeTree$ | async)"
        cdkDrag
        [cdkDragDisabled]="(isAdmin$ | async) ? false : !(hasWritePermissionOnAtLeastOneCustomerOUInCurrentNodeTree$ | async)"
        >
        <app-doenkids-image
          [preview]="true"
          [mediaItem]="template.media_uuid"
          [maxWidth]="100"
        ></app-doenkids-image>
        <span>{{template.name}}</span>
      </div>
    }
  </div>
</ng-template>

<ng-template #programCategoryTemplateBundleList>
  <div cdkDropList class="program-category-template-bundle-list" (cdkDropListDropped)="droppedTemplateBundle($event)">
    @for (templateBundle of programCategoryTemplateBundles; track templateBundle) {
      <div class="category-box" [class.draggable]="(isAdmin$ | async) || (hasWritePermissionOnAtLeastOneCustomerOUInCurrentNodeTree$ | async)"
        cdkDrag
        [cdkDragDisabled]="(isAdmin$ | async) ? false : !(hasWritePermissionOnAtLeastOneCustomerOUInCurrentNodeTree$ | async)"
        >
        <app-doenkids-image
          [preview]="true"
          [mediaItem]="templateBundle.media_uuid"
          [maxWidth]="100"
        ></app-doenkids-image>
        <span>{{templateBundle.name}}</span>
      </div>
    }
  </div>
</ng-template>
</app-page-content>
